export default "__VITE_ASSET__Bj5lgu60__"